import { CSSProperties } from 'react';
import { custom2, primary } from 'assets/colors/colors';

export const staticDateRangeActiveStyles: CSSProperties = {
  background: custom2.text,
  color: primary.contrastText,
  fontWeight: 'bold',
};
export const errorStyles: CSSProperties = {
  outline: '1px solid red',
  borderRadius: '5px',
};
